import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "18",
      height: "14",
      x: "3",
      y: "5",
      stroke: "#3B82F6",
      "stroke-width": "1.5",
      rx: "2"
    }, null, -1),
    _createElementVNode("rect", {
      width: "6",
      height: "4",
      x: "5",
      y: "8",
      stroke: "#3B82F6",
      "stroke-width": "1.5",
      rx: "1"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#3B82F6",
      "stroke-linecap": "round",
      "stroke-width": "1.5",
      d: "M13 9h4M13 12h4M5 15h12"
    }, null, -1)
  ]))]))
}
export default { render: render }